/* eslint-disable */

export default {
  init() {


    // aggiunge il target blank a tutti i link esterni
    (() => {
      (document.querySelectorAll('a')).forEach(link => {
        link.hostname !== location.hostname && link.setAttribute('target', '_blank');
      })
    })();

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singlePortfolio.js